//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
import { i18n } from "boot/i18n";
import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';;

String.prototype.splice = function (start, delCount, newSubStr) {
  return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
};

export default {
  name: "App",
  data: function data() {
    return {
      loaded: false
    };
  },
  created: function created() {
    this.loadTranslations();
    this.setDefaultLoading();
  },
  methods: {
    loadTranslations: function loadTranslations() {
      // Set locale to 'en' in dev mode.
      // let lang = process.env.DEV ? "nl" : navigator.language.substring(0, 2);
      var lang = "nl";
      var thiss = this; // As we are getting languages from the database, the locale 'en' is just for it to not give an error.

      axios.post(process.env.BASE_API_URL + "/translations", {
        language: lang
      }).then(function (response) {
        thiss.loaded = true;
        i18n.setLocaleMessage("en", response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    setDefaultLoading: function setDefaultLoading() {
      Loading.setDefaults({
        spinner: QSpinnerPie,
        spinnerColor: "deep-purple-2"
      });
    }
  }
};